module.exports = __webpack_public_path__ + "static/img/Brett-Kenny.b1da14b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brett-Kenny.jpg
// module id = QzR9
// module chunks = 0